// Chamada no My Planner Web: a sala pronta do LiveKit (vídeo em grade, microfone, câmera, compartilhar a tela, chat).
import { useEffect, useState } from 'react';
import { ActivityIndicator, Pressable, Text, View } from 'react-native';
import { LiveKitRoom, RoomAudioRenderer, VideoConference, useRoomContext } from '@livekit/components-react';
import '@livekit/components-styles';
import { avisarFimDaChamada, encerrarNoServidor, erroDaSala, pedirSala, type Sala } from '../lib/chamada';
import { GravarReuniao } from './GravarReuniao';
import { t } from '../lib/i18n';

/** Gravação por cima da sala pronta do LiveKit (precisa estar dentro do LiveKitRoom). */
function Gravar({ conversa }: { conversa: string }) {
  const room = useRoomContext();
  return <View style={{ position: 'absolute', top: 8, left: 0, right: 0, zIndex: 10 }} pointerEvents="box-none"><GravarReuniao conversa={conversa} room={room} /></View>;
}

type Props = { conversa: string; tipo: 'audio' | 'video'; nome: string; dupla: boolean; onFim: () => void };

export function TelaChamada({ conversa, tipo, nome, dupla, onFim }: Props) {
  const [sala, setSala] = useState<Sala | null>(null);
  const [erro, setErro] = useState('');
  useEffect(() => { pedirSala(conversa, tipo).then(setSala).catch(e => setErro(erroDaSala(e))); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  if (erro || !sala) return (
    <View style={{ flex: 1, backgroundColor: '#0B0D12', alignItems: 'center', justifyContent: 'center', padding: 28, gap: 16 }}>
      {!erro ? <ActivityIndicator color="#fff" /> : <Text style={{ fontSize: 44 }}>📞</Text>}
      <Text style={{ color: '#fff', textAlign: 'center' }}>{erro || t('Conectando...')}</Text>
      {!!erro && <Pressable onPress={onFim} style={{ backgroundColor: '#374151', paddingHorizontal: 22, paddingVertical: 12, borderRadius: 14 }}>
        <Text style={{ color: '#fff', fontWeight: '700' }}>{t('Voltar')}</Text></Pressable>}
    </View>
  );
  return (
    <View style={{ flex: 1, backgroundColor: '#0B0D12' }}>
      <Text style={{ color: '#fff', fontWeight: '800', padding: 12 }}>{nome}</Text>
      <div data-lk-theme="default" style={{ flex: 1, height: 'calc(100% - 44px)' }}>
        <LiveKitRoom serverUrl={sala.url} token={sala.token} connect audio video={sala.tipo === 'video'} style={{ height: '100%' }}
          onError={e => setErro(erroDaSala(e))}
          onDisconnected={() => { if (dupla) encerrarNoServidor(sala.id); avisarFimDaChamada(sala.id); onFim(); }}>
          <VideoConference />
          {!dupla && <Gravar conversa={conversa} />}
          <RoomAudioRenderer />
        </LiveKitRoom>
      </div>
    </View>
  );
}
